import { CLASSIC_TRADE_IN_SUB_TYPE, EASY_TRADE_IN_SUB_TYPE } from '@constants/easy-trade-in';

export type EasyTradeInCharacteristic = {
    type: 'CARACTERISTIQUE_SIMPLE';
    typeCaracteristique: string;
    valeur: string;
};

export type EasyTradeInResource = {
    typeRessource: 'PARTENAIRE';
    caracteristiques: EasyTradeInCharacteristic[];
};

export type EasyTradeInProductApi = {
    sousType: string; // CLASSIC_TRADE_IN_SUB_TYPE | EASY_TRADE_IN_SUB_TYPE
    prix: {
        final: number;
    };
    caracteristiques?: EasyTradeInCharacteristic[];
    ressourcesAttribuees?: EasyTradeInResource[];
};

export type EasyTradeInEligibilityResponse = {
    nombreTotalProduits: number;
    produits: EasyTradeInProductApi[];
    initiateur: string;
};

export type EasyTradeInEligibility = {
    hasClassicTradeIn: boolean;
    hasEasyTradeIn: boolean;
    partnerProductId?: string;
    creditId?: string;
};

export type EasyTradeInPhoneInfo = {
    id: string;
    name: string;
    brand: string;
};

export enum EasyTradeInChoice {
    RETURN = 'return',
    KEEP = 'keep',
}

export enum EasyTradeInStatus {
    NOT_STARTED = 'not_started',
    SETTLED = 'settled',
    TOO_LOW = 'too_low',
    PARTIAL = 'partial',
}

export type EasyTradeInResult = {
    status: EasyTradeInStatus;
    remainingCredit: number;
    remainingCreditTerminal: number;
    creditBeforeTradeIn: number;
    estimatedValue: number;
    partnerRequestId?: string;
    creditAccessories: number;
};

export type TradeInSubType = typeof EASY_TRADE_IN_SUB_TYPE | typeof CLASSIC_TRADE_IN_SUB_TYPE;
